module.exports = __webpack_public_path__ + "public/static/img/pp-logo.ee56c19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pp-logo.svg
// module id = m+Bb
// module chunks = 1